import type { jsPDF } from 'jspdf';

const FONT_FILE = 'NotoSansArabic.ttf';
const FONT_NAME = 'NotoSansArabic';
const FONT_URL = '/fonts/NotoSansArabic-Regular.ttf';

let loadPromise: Promise<void> | null = null;

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}

/** Registers Noto Sans Arabic with jsPDF (cached after first load). */
export async function ensureArabicPdfFont(doc: jsPDF): Promise<void> {
  if (loadPromise) {
    await loadPromise;
    doc.setFont(FONT_NAME);
    return;
  }

  loadPromise = (async () => {
    const res = await fetch(FONT_URL);
    if (!res.ok) throw new Error('Failed to load Arabic PDF font');
    const base64 = arrayBufferToBase64(await res.arrayBuffer());
    doc.addFileToVFS(FONT_FILE, base64);
    doc.addFont(FONT_FILE, FONT_NAME, 'normal');
  })();

  await loadPromise;
  doc.setFont(FONT_NAME);
}

export function hasArabicText(text: string): boolean {
  return /[\u0600-\u06FF]/.test(text);
}
